import { render, staticRenderFns } from "./WizardViewAdvertising.vue?vue&type=template&id=0a902c0a&"
import script from "./WizardViewAdvertising.vue?vue&type=script&lang=js&"
export * from "./WizardViewAdvertising.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports